import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
  Checkbox as SemanticCheckbox,
  Message as SemanticMessage,
} from 'semantic-ui-react';
import { Text as TextLayout } from '@playbookux/playbook-web-core';

const Dropdown = styled(SemanticDropdown)`
  &&& {
    min-width: 14em;
    height: ${({ height }) => height || '40px'};
  }

  &.ui.dropdown > .text {
    font-weight: 500;
    margin-left: 10px;
  }

  &&&.ui.dropdown .menu>.item{
    padding: 0 !important;
  }
  
`;

const Checkbox = styled(SemanticCheckbox)`
  &&& {
    width: 100%;
    padding: .7rem 1rem;
  }
`;

const Text = styled(TextLayout)`
  font-weight: 400;
`;

const Message = styled(SemanticMessage)``;

export {
  Dropdown,
  Checkbox,
  Text,
  Message,
};
